import * as React from "react";
import { IconProps } from "./types";

export const AlignBottom01Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M3 21H21M12 3V17M12 17L19 10M12 17L5 10"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(AlignBottom01Icon as React.FunctionComponent).displayName =
  "AlignBottom01Icon";

export default AlignBottom01Icon;
